import React from "react";
import styled, { keyframes } from "styled-components";

const CollaborationContentLoading = () => (
  <LoadingRoot role="status" aria-label="Inhalt wird geladen">
    <Spinner />
  </LoadingRoot>
);

export default CollaborationContentLoading;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const LoadingRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 48px 0;
`;

const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #e2dfd8;
  border-top-color: #0a7c4e;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;
